export enum ProjectTypeEnum {
    AccountingStandardization,
    KpiBenchmarkingReport,
    MnaTransaction,
    Other,
    Template,
    CapvarDataInput,
    ApvarDataInput,
    MarketplaceEngagement
}

export interface ProjectTypeEnumItem {
    id: number;
    name: string;
}

export const ProjectTypeEnumList = [
    {
        id: 0,
        name: 'Accounting Standardization',
    },
    {
        id: 1,
        name: 'KPI Benchmarking',
    },
    {
        id: 2,
        name: 'M&A Transaction',
    },
    {
        id: 3,
        name: 'Other',
    },
    {
        id: 4,
        name: 'Template',
    },
    {
        id: 5,
        name: 'CAPVAR Data Input',
    },
    {
        id: 6,
        name: 'APVAR Data Input',
    },
    {
        id: 7,
        name: 'Marketplace Engagement',
    }
];
